export default [
  {
    path: '/help',
    name: 'help',
    // redirect: '/help',
    meta: {
      title: '协议',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/help/Index.vue'),
        meta: {
          title: '帮助',
        },
      },
    ],
  },
]
